export const shouldShowPillLauncher = ({
  usePillLauncher,
  hasOpenedWidget,
  mobile
}) => usePillLauncher && !hasOpenedWidget && !mobile;